import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FirmwareVersion } from '../../../shared/services/firmware-update-api/firmware-update-api.service';

@Injectable({
  providedIn: 'root',
})
export class FirmwareService {
  url: string = environment.modularUpdate;
  firmwareServiceUrl: string = environment.firmwareUpdateService;

  constructor(private httpClient: HttpClient) {}

  //This returns all the module versions that are present in the system.
  getModules(): Promise<Module[]> {
    return this.httpClient
      .get<Module[]>(`${this.url}/modules/versions`)
      .toPromise();
  }

  getModuleVersionsByName(name: string): Promise<Module[]> {
    return this.httpClient
      .get<Module[]>(`${this.url}/modules/${name}/versions`)
      .toPromise();
  }

  postModuleVersion(
    name: string,
    file: Blob,
    signature: string,
    config?: JSON,
    zsync?: Blob,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('signature', signature);

    if (config) {
      formData.append('configurationSchema', JSON.stringify(config));
    }

    if (zsync) {
      formData.append('zsyncFile', zsync);
    }

    return this.httpClient.post(
      `${this.url}/modules/${name}/versions`,
      formData,
    );
  }

  getModuleNames(): Promise<ModuleName[]> {
    return this.httpClient.get<ModuleName[]>(`${this.url}/modules`).toPromise();
  }

  getModuleByName(name: string): Promise<ModuleName> {
    return this.httpClient
      .get<ModuleName>(`${this.url}/modules/${name}`)
      .toPromise();
  }

  postModuleName(moduleName: ModuleName): Promise<unknown> {
    return this.httpClient.post(`${this.url}/modules`, moduleName).toPromise();
  }

  getFirmwareVersionsByName(): Promise<FirmwareVersion[]> {
    const name = 'LcFlex';
    return this.httpClient
      .get<
        FirmwareVersion[]
      >(`${this.firmwareServiceUrl}/platforms/${name}/firmwareVersions`)
      .toPromise();
  }

  createFirmwareVersion(
    platforType: string,
    firmwareName: string,
    file: Blob,
  ): Observable<unknown> {
    const firmwareUrl = `${this.firmwareServiceUrl}/platforms/${platforType}/firmwareVersions/${firmwareName}`;
    return this.httpClient.post<void>(firmwareUrl, file, {
      headers: new HttpHeaders({}),
      responseType: 'json',
    });
  }
}

export enum PlatformType {
  Otto = 'Otto',
  LcFlex = 'LcFlex',
}

export interface Module {
  id?: string;
  platform: string;
  hardwarePlatform?: string;
  name: string;
  version: string;
  fileName?: string;
  configuration?: string;
  configurationSchema?: string;
}

export interface ModuleName {
  name: string;
  description: string;
  icon: string;
}

export interface ModuleVersion {
  id?: string;
  platform: string;
  hardwarePlatform?: string;
  name: string;
  version: string;
  configuration?: string;
  configurationSchema?: string;
}

export interface Deployment {
  id: string;
  name: string;
  description: string;
  modules: Module[];
  entities: Entity[];
}

export interface Entity {
  type: string;
  id: string;
}

export interface CreateDeploymentRequest {
  name: string;
  description: string;
  modules: Module[];
  entities: Entity[];
}
